import ChatInputAdorements from "src/reusable/Chat/PromptInput/ChatInputAdorements";
import ChatPersonaSelectButton from "src/reusable/Chat/PromptInput/ChatPersonaSelectButton";
import { Stack } from "@mui/material";

type ChatInputButtonsProps = {
  isInputting: boolean;
  isChatLoading: boolean;
  isGenerating: boolean;
  handleFormSubmit: (event: React.FormEvent | React.KeyboardEvent) => void;
  onStopChat: () => void;
};

const PartsAIChatInputButtons = ({
  isInputting,
  isChatLoading,
  isGenerating,
  handleFormSubmit,
  onStopChat,
}: ChatInputButtonsProps) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-end"
      sx={{ width: "100%" }}
      gap={2}
    >
      <ChatPersonaSelectButton />
      <Stack direction="row" justifySelf="flex-end" alignItems="center" gap={2}>
        <ChatInputAdorements
          isInputting={isInputting}
          isChatLoading={isChatLoading}
          isGenerating={isGenerating}
          handleFormSubmit={handleFormSubmit}
          onStopChat={onStopChat}
        />
      </Stack>
    </Stack>
  );
};

export default PartsAIChatInputButtons;
